import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgrxFormsModule } from 'ngrx-forms';

import { ComponentsModule } from '@locumsnest/components/src';

import { CommonMessagingPanelModule } from '../core/containers/common-messaging-panel/common-messaging-panel.module';
import { RotaRoutingModule } from './rota-routing.module';

@NgModule({
  declarations: [],
  imports: [
    FormsModule,
    NgrxFormsModule,
    CommonModule,
    ComponentsModule,
    RotaRoutingModule,
    CommonMessagingPanelModule,
  ],
})
export class RotaModule {}
